// Shared store for the WorldSoccerPins club-logo catalog (name_norm -> logo URL).
// Used by <TeamBadge> so standings/comparison tables show the same crests as the diagrams.
// ensureClubLogos() lazily resolves + downloads any missing crests for a list of names.
import { useSyncExternalStore } from "react";
import api from "@/lib/api";

export const normClub = (s) => String(s || "").trim().toLowerCase().split(/\s+/).join(" ");

let _map = {};
let _loaded = false;
let _loading = false;
const _ensured = new Set();
const subs = new Set();
const emit = () => subs.forEach((f) => f());

function load() {
  if (_loading || _loaded) return;
  _loading = true;
  api.get("/clubs/logo-map")
    .then((r) => { _map = r.data || {}; _loaded = true; _loading = false; emit(); })
    .catch(() => { _loading = false; });
}

// Resolve+download missing crests for the given club names (once each), then merge into the store.
export function ensureClubLogos(names) {
  const missing = (names || []).filter((n) => n && !_map[normClub(n)] && !_ensured.has(normClub(n)));
  if (!missing.length) return;
  missing.forEach((n) => _ensured.add(normClub(n)));
  api.post("/clubs/logo-ensure", { names: missing })
    .then((r) => { _map = { ..._map, ...(r.data || {}) }; _loaded = true; emit(); })
    .catch(() => {});
}

// Clear the cache on login/logout so one org's crests never show for another.
export function resetClubLogos() { _map = {}; _loaded = false; _loading = false; _ensured.clear(); emit(); }

export function useClubLogoStore() {
  return useSyncExternalStore(
    (cb) => { subs.add(cb); load(); return () => subs.delete(cb); },
    () => _map,
    () => _map,
  );
}

// Non-hook getter for use outside React (e.g. PDF builders). Returns a data URL or null.
export function clubLogoFor(name) { return _map[normClub(name)] || null; }
